/* eslint-disable no-console */
import { fetchJSON } from '@bonnet/next/fetch';
import CircuitBreaker from '@/utilities/circuitbreaker/withCircuitBreaker';
import { fetchLoader } from '@/utilities/cache';
import { onSuccess, onFailure } from '@/utilities/circuitbreaker/handlers';

const eventName = 'FetchVehicleDataServiceLoader';

const successHandler = (result) => {
    onSuccess(eventName, result);
};

const failureHandler = (err, latency, args) => {
    onFailure(eventName, err, latency, args);
};

// Used by mywallet to fetch vehicle information from both vrs/researchable api
export default async (endpoint, query = {}) => {
    try {
        const useDataFetcher = endpoint.includes('/data/');
        const vehicleDataEndpoint = useDataFetcher ? endpoint.replace('/data/', '') : `/collections/vrs${endpoint}`;

        // Used specifically for the "vrs/valuations/values" endpoint
        if (!useDataFetcher) {
            return fetchJSON(vehicleDataEndpoint, query);
        }

        const baseUrl = `/collections/webapiServices/${vehicleDataEndpoint}`; // go through bonnet proxy for client-side calls
        const queryString = new URLSearchParams(query).toString();
        const vehicleDataServiceLoader = fetchLoader({ name: eventName, url: baseUrl, params: query, ssr: false });

        const resp = await CircuitBreaker.withCircuitBreaker(
            eventName,
            vehicleDataServiceLoader.load,
            [`${baseUrl}?${queryString}`],
            {
                circuitBreakerOptions: {
                    timeout: process.env.CIRCUIT_BREAKER_TIMEOUT,
                },
                additionalOptions: {
                    onFallback: {},
                    key: `${baseUrl}?${queryString}`,
                    additionalEventHandlers: {
                        flipper: true,
                        events: [
                            { name: 'onSuccess', event: 'success', handler: successHandler },
                            { name: 'onFailure', event: 'failure', handler: failureHandler },
                        ],
                    },
                },
            }
        );
        return resp.data;
    } catch (err) {
        console.log(`${eventName}: Error fetching vehicle data`, err);
        return {};
    }
};
